import { render, staticRenderFns } from "./EditableAliasTableItem.vue?vue&type=template&id=6504f17a&scoped=true"
import script from "./EditableAliasTableItem.vue?vue&type=script&lang=js"
export * from "./EditableAliasTableItem.vue?vue&type=script&lang=js"
import style0 from "./EditableAliasTableItem.vue?vue&type=style&index=0&id=6504f17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504f17a",
  null
  
)

export default component.exports